import React from "react";
import {
  BooleanInput,
  Edit,
  FormTab,
  TabbedForm,
  TextField,
  TextInput
} from "react-admin";

const PersonEdit = (props) => {
  return (
    <Edit undoable={false} {...props}>
      <TabbedForm>
        <FormTab label="summary">
          <TextField source="id" />
          <TextInput source="stableId" />
          <TextInput source="firstName" />
          <TextInput source="lastName" />
          <TextInput source="middleInitial" />
          <BooleanInput source="isStub" />
        </FormTab>
        <FormTab disabled label="team-seasons"></FormTab>
      </TabbedForm>
    </Edit>
  );
};

export default PersonEdit;
